<template>
  <div class="order-detail-page full-height display-col">
    <full-con :canReturn="canReturn">
      <div slot="editBreadcrumb">
        <editBreadcrumb :pageTitle="pageTitle"></editBreadcrumb>
      </div>
      <div slot="full">
        <el-button type="primary" style="margin-bottom:15px" @click="handleExport">
          {{$t('export')}}</el-button>
        <el-form>
          <div class="tabel-container">
            <el-row class="table-content">
              <el-col :span="24" class="content">
                <el-row>
                  <el-col :span="10" class="labelTitle"> <span class="el-icon-document">&nbsp;{{$t('fba.billNo')}}</span></el-col>
                  <el-col :span="14" class="labelValue">{{paymentInfo.billNo}}</el-col>
                </el-row>
                <el-row>
                  <!-- <el-col :span="5" class="labelTitle">{{$t('fba.orderType')}}</el-col>
                  <el-col :span="7" class="labelValue">{{paymentInfo.orderType | orderTypeFilter}}</el-col> -->
                  <el-col :span="10" class="labelTitle">{{$t('fba.batchNo')}}</el-col>
                  <el-col :span="14" class="labelValue">{{paymentInfo.containerBatchNo}}</el-col>
                </el-row>
                <el-row>
                  <el-col :span="10" class="labelTitle">{{$t('OrderDetail.OrderDetail27')}}</el-col>
                  <el-col :span="14" class="labelValue">{{paymentInfo.freight}}元</el-col>
                </el-row>
              </el-col>
            </el-row>
          </div>
          <div class="tabel-container">
            <el-row class="table-content">
              <el-col :span="24" class="content">
                <el-row>
                  <el-col :span="10" class="labelTitle">{{$t('fba.totalGoods')}}</el-col>
                  <el-col :span="14" class="labelValue">{{paymentInfo.batchOrderAmountAll}}元</el-col>
                </el-row>
                <el-row>
                  <el-col :span="10" class="labelTitle">{{$t('OrderDetail.OrderDetail30')}}</el-col>
                  <el-col :span="14" class="labelValue">{{paymentInfo.total}}元</el-col>
                </el-row>
              </el-col>
            </el-row>
          </div>
          <br />
          <div class="tabel-container">
            <div style="text-align: center" v-if="isEditPage==1">
              <div v-if="payFail">
                <el-button type="info" style="width: 300px">{{$t('fba.rechargeTip')}}</el-button>
                <el-link :underline="false" style="margin-left: 10px">{{$t('fba.toRecharge')}}</el-link>
              </div>
            </div>
          </div>
        </el-form>
        <div class="title">
          <div class="strong">{{$t('OrderDetail.OrderDetail27') }}</div>
          <div>{{$t('OrderBill.OrderBill20') }}：{{ paymentInfo.payTime | dateFormatToSecond }}</div>
        </div>
        <el-table show-summary :summary-method="getSummaries" :data="paymentInfo.freightList" border stripe style="width: 100%"
          :header-cell-style="tableStyle.headerStyle" :cell-style="tableStyle.cellStyle">
          <el-table-column type="index" :label="$t('wzbg.wz6')" align="center" width="50"></el-table-column>
          <el-table-column prop="payName" :label="$t('fba.project')" align="center"></el-table-column>
          <el-table-column prop="price" :label="$t('fba.price')" align="center"></el-table-column>
          <el-table-column prop="count" :label="$t('excel.excel7')" align="center"></el-table-column>
          <el-table-column prop="discountAmount" :label="$t('fba.discount')" align="center"></el-table-column>
          <el-table-column prop="receivedAmount" :label="$t('fba.totalAmount')" align="center"></el-table-column>
        </el-table>
        <div class="title">
          <div class="strong">{{$t('fba.totalGoods')}}</div>
          <el-button type="primary" style="width: 300px" @click="paymentPay" v-if="containerState==1">{{$t('fba.payNow')}}
          </el-button>
        </div>
        <el-table show-summary :summary-method="getSummaries1" :data="paymentInfo.goodsList" border stripe style="width: 100%"
          :header-cell-style="tableStyle.headerStyle" :cell-style="tableStyle.cellStyle">
          <el-table-column type="index" :label="$t('wzbg.wz6')" align="center" width="50"></el-table-column>
          <el-table-column prop="goodsName" :label="$t('fba.productName')" align="center"></el-table-column>
          <el-table-column prop="orderNo" :label="$t('fba.orderNo')" align="center"></el-table-column>
          <el-table-column prop="orderType" label="FBA/RSL/YFFコード" align="center" width="150"></el-table-column>
          <el-table-column prop="skuNo" label="SKU" align="center"></el-table-column>
          <el-table-column prop="pictureUrl" :label="$t('BuddleOrderDetail.BuddleOrderDetail8')" align="center">
            <template v-slot="scope">
              <img v-if="scope.row.pictureUrl" :src="scope.row.pictureUrl" alt="">
              <img v-else src="../../assets/images/default.png" alt="" class="list-image">
            </template>
          </el-table-column>
          <el-table-column prop="price" :label="$t('fba.price')" align="center"></el-table-column>
          <el-table-column prop="boxCount" :label="$t('fba.number')" align="center"></el-table-column>
          <el-table-column prop="goodsAmount" :label="$t('OrderDetail.OrderDetail47')" align="center"></el-table-column>
          <el-table-column prop="orderAgentServiceFee" :label="$t('OrderDetail.OrderDetail29')" align="center"></el-table-column>
          <el-table-column prop="orderInlandFreight" :label="$t('orderList.orderList119')" align="center"></el-table-column>
          <el-table-column prop="orderProblemHandlingFee" :label="$t('defe.defe100')" align="center"></el-table-column>
          <el-table-column prop="orderReturnFee" :label="$t('defe.defe83')" align="center"></el-table-column>
          <el-table-column prop="configCheckProjectPrice" :label="$t('OrderDetail.OrderDetail38')" width="250" align="center">
            <template v-slot="scope">
              <div v-for="(item,index) in  scope.row.configCheckProject" :key="index">
                {{item.checkName}}： {{item.price}}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="orderLabelFee" :label="$t('OrderDetail.OrderDetail39')" align="center"></el-table-column>
          <el-table-column prop="orderCategoryPrice" :label="$t('OrderDetail.OrderDetail35')" align="center"></el-table-column>
          <el-table-column prop="batchOrderAmount" :label="$t('fba.totalAmount1')" align="center"></el-table-column>
        </el-table>
        <div style="margin-top:15px">{{$t('fba.fbaa1')}}</div>
        <div>{{$t('fba.fbaa2')}}</div>
        <div>{{$t('fba.fbaa3')}}</div>
        <div>{{$t('fba.fbaa4')}}</div>
      </div>
    </full-con>
  </div>
</template>

<script>
export default {
  data () {
    return {
      canReturn: '1',
      pageTitle: this.$t('fba.bill'),
      containerBatchNo: '',
      list: [1, 1, 1, 1, 1],
      isEditPage: 0,
      configPayProject: {},
      paymentInfo: {},
      paymentItemList: [],
      payBtn: true,
      containerState: "",
      payFail: false,
    }
  },
  methods: {
    getSummaries (param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = this.$t('OrderDetail.OrderDetail30');
          return;
        }
        if (index === 1) {
          sums[index] = '';
          return
        }
        const values = data.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index] += ' 元';
        } else {
          sums[index] = '';
        }
      });

      return sums;
    },
    handleExport () {
      let data = {
        containerBatchNo: this.containerBatchNo,
      }
      this.$http({
        url: "container/exportObtainFBAOrder",
        method: 'post',
        data,
        responseType: 'blob', // 表明返回服务器返回的数据类型
        headers: {
          'Content-Type': 'application/json'
        },
      }).then((res) => {
        //创建一个隐藏的a连接，
        const link = document.createElement('a');
        let blob = new Blob([res.data], { type: 'application/vnd.ms-excel' });
        link.style.display = 'none';
        //设置连接
        link.href = URL.createObjectURL(blob);
        link.download = `账单.xlsx`;
        document.body.appendChild(link);
        //模拟点击事件
        link.click();
      }).catch(() => {
      })
    },
    getSummaries1 (param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = this.$t('OrderDetail.OrderDetail30');
          return;
        }
        if (index === 1 || index === 2 || index === 3 || index === 4 || index === 5) {
          sums[index] = '';
          return;
        }
        if (index === 11) {
          const values1 = data.map(item => Number(item['configCheckProjectPrice']));
          sums[11] = values1.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
           sums[index] = sums[index].toFixed(2)
          sums[index] += '元';
          return;
        }
        const values = data.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index] = sums[index].toFixed(2)
          sums[index] += ' 元';
        } else {
          sums[index] = '';
        }
      });

      return sums;
    },

    //获取收费项目
    async getConfigPayProject () {
      const { data: res } = await this.$http.get('configPayProject/getAllConfigPayProject');
      this.configPayProject = res.data;
    },//获取账单信息
    async getOrderBill () {
      const { data: res } = await this.$http.post('container/getObtainFBAOrder', { "containerBatchNo": this.containerBatchNo, 'toCFlag': '1' });
      this.paymentInfo = res.data;
      console.log(res.data)
      this.paymentItemList = this.paymentInfo.list;
    },
    async savePost () {
      const { data: res } = await this.$http.post('order/payment/pay', { id: this.paymentInfo.id });
      if (res.code == 200) {
        this.$message.success(res.message);
        this.$router.go(-1);
      }
      else {
        //余额不足
        if (res.code == 1000) {
          this.payBtn = false;
          this.payFail = true;
        } else {
          this.$message.error(res.message);
        }
      }
    },//金额格式
    priceShow (row, column, cellValue, index) {
      let ret = ''
      ret = cellValue + '元'
      return ret
    },//收费项目格式
    payProjectFormat (row, column, cellValue, index) {
      if (this.configPayProject.length > 0) {
        let payProject = this.configPayProject.filter(function (item) {
          return item.value == cellValue;
        });

        let payProjectName = '';
        if (payProject && payProject.length > 0) {
          payProjectName = payProject[0].name
        }

        return payProjectName;
      }

    },//支付账单
    paymentPay () {
      console.log(this.paymentInfo)
      this.$confirm(this.$t('fba.confirmPay'), this.$t('common.tip'), {
        confirmButtonText: this.$t('common.confirm'),
        confirmButtonClass: "form-btn btn-blue",
        cancelButtonText: this.$t('common.cancel'),
        cancelButtonClass: "form-btn btn-gray",
        type: 'warning'
      }).then(async () => {
        const { data: res } = await this.$http.post('container/FBAPayment', {
          containerBatchNo: this.paymentInfo.containerBatchNo,
          paymentNumber: this.paymentInfo.billNo,
          totalAmount: this.paymentInfo.total,
          receivedAmount: this.paymentInfo.freight,
          balance: this.paymentInfo.balance
        });
        if (res.code == 200) {
          this.$message.success(res.message);
          this.$router.go(-1);
        }
        else {
          //余额不足
          if (res.code == 1000) {
            this.payBtn = false;
            this.payFail = true;
          } else {
            this.$message.error(res.message);
          }
        }
      });
    }
  },
  created () {
    this.containerBatchNo = this.$route.query.containerBatchNo;
    this.isEditPage = this.$route.query.isEdit;
    this.containerState = this.$route.query.containerState
    this.getConfigPayProject();
    this.getOrderBill();
  }
}
</script>

<style lang="less" scoped>
.title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 15px 0;
  .strong {
    font-weight: bold;
    font-size: 20px;
  }
}
.order-detail-container {
  background: #fff;
  padding: 20px;
}
ul,
li {
  list-style: none;
}
.labelTitle {
  text-align: left;
}
.labelValue {
  text-align: right;
}
.table-title {
  padding: 5px 0;
  text-align: center;
  background: #f1f2f6;
}
.table-content .content .el-col {
  height: 35px;
  line-height: 30px;
  padding: 0 2px;
  border-bottom: 1px solid #e5e9f8;
  // white-space:nowrap;
  // text-overflow:ellipsis;
  overflow: auto;
}
.el-form-item {
  margin-bottom: 0 !important;
}
/deep/.el-form-item__content {
  line-height: 30px !important;
}
/deep/ .el-icon-document {
  font-size: 17px;
}
.amountShow {
}
.amountShow span {
  display: block;
  color: red;
}
.amountShow .span1 {
  text-decoration: line-through;
  color: #333333;
  text-decoration-color: red;
}
// .table-content .content{
//   padding-bottom: 10px;
// }
</style>

